


// import React, { useState, useEffect } from "react";
// import { socket } from "../helpers/socketInstance";
// import './TruckBoard.css';

// const TruckDisplay = () => {
//   const [truckData, setTruckData] = useState([]);
//     const [alertTruck, setAlertTruck] = useState({ vehicle: '', bay: '' });

//   // Dummy API Fetch Simulation
//   const fetchTruckData = () => {
//     const dummyData = [
//       {
//         id: 1,
//         vehicleNumber: "DL22KLM12345",
//         date: "21-03-2025",
//         time: "10:45 AM",
//         bay: "AR-28",
//         status: "Unloading",
//       },
//       {
//         id: 2,
//         vehicleNumber: "DL22KLM12346",
//         date: "21-03-2025",
//         time: "11:15 AM",
//         bay: "AQ-45",
//         status: "Delayed",
//       },
//       // Add more rows as per your design
//     ];
//     setTruckData(dummyData);
//      setAlertTruck({ vehicle: dummyData[0].vehicleNumber, bay: dummyData[0].bay }); 
//   };

//   useEffect(() => {
//     // Initial Data
//     fetchTruckData();

//     // Socket Listener
//     socket.on("connect", () => {
//       console.log("Socket connected:", socket.id);
//     });

//     socket.on("disconnect", () => {
//       console.log("Socket disconnected");
//     });

//     socket.on("truckStatusUpdate", (data) => {
//       console.log("Received truckStatusUpdate:", data);

//       // Always use functional update to get latest state
//       setTruckData((prevData) => {
//         const updated = prevData.map((truck) => {
//           if (truck.id === data.truckId) {
//             return { ...truck, status: data.status };
//           }
//           return truck;
//         });
//         console.log("Updated truckData:", updated); // Debugging
//         return updated;
//       });

//       // Optional: Alert Truck - We update separately after data update
//       setAlertTruck((prev) => ({
//         vehicle: `Truck ID: ${data.truckId}`,
//         bay: '' // You can customize here if you want bay info
//       }));
//     });

//     // Cleanup
//     return () => {
//       socket.off("connect");
//       socket.off("disconnect");
//       socket.off("truckStatusUpdate");
//     };
//   }, []);


//   return (
//     <div className="board-container">
//         <div className="left-section">
//         <div className="header">DATE & TIME</div>

//       <table className="truck-table">
//         <thead>
//         <tr>
//                <th>#</th>
//                <th>Vehicle Number</th>
//                <th>Date</th>
//                <th>Allotted Time</th>
//                <th>Bay</th>
//                <th>Status</th>
//            </tr>
//         </thead>
//         <tbody>
//           {truckData.map((truck) => (
//             <tr key={truck.id}>
//               <td>{truck.id}</td>
//               <td>{truck.vehicleNumber}</td>
//               <td>{truck.date}</td>
//               <td>{truck.time}</td>
//               <td>{truck.bay}</td>
//               <td
//                 style={{
//                   color:
//                     truck.status === "Delayed"
//                       ? "red"
//                       : truck.status === "Unloading"
//                       ? "green"
//                       : truck.status === "Parking"
//                       ? "orange"
//                       : "white",
//                 }}
//               >
//                 {truck.status}
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//       </div>

//       <div className="right-section">
//          <h2>ALERT</h2>
//          <h3>{alertTruck.vehicle}</h3>
//         <p>BAY: {alertTruck.bay}</p>
//      </div>

//     </div>
//   );
// };

// export default TruckDisplay;

import React, { useEffect, useState } from "react";
import { socket } from "../helpers/socketInstance";
import axiosInstance from "../helpers/axiosInstance";

const Dashboard = () => {
  const [dateTime, setDateTime] = useState(new Date());
  const [truckData, setTruckData] = useState([]);
  const [alertTruck, setAlertTruck] = useState(null);



  const fetchTruckData = async () => {
    try {
      const res = await axiosInstance.get("/api/auth/sendIntialDataToLiveBoard");

      const mappedData = (res.data.data || []).map((item, index) => ({
        slNo: index + 1,
        vehicleNo: item.vehicle_number,
        bayNo: item.bay,
        time: item.bay_entry_time,
        bayStatus: item.status, // keep original status
        id: item.id
      }));

      setTruckData(mappedData);
      console.log("Fetched Truck Data:", mappedData);
    } catch (err) {
      console.error("Error fetching live board data:", err);
    }
  };


  // useEffect(() => {
  //   fetchTruckData();

  //   socket.on("connect", () => {
  //     console.log("Socket connected:", socket.id);
  //   });

  //   socket.on("disconnect", () => {
  //     console.log("Socket disconnected");
  //   });

  //   socket.on("truckStatusUpdate", (data) => {
  //     console.log("Received truckStatusUpdate:", data);

  //     setTruckData((prevData) => {
  //       const updated = prevData.map((truck) =>
  //         truck.id === data.truckId ? { ...truck, status: data.status } : truck
  //       );
  //       return updated;
  //     });

  //     // Set alert for updated truck
  //     setAlertTruck({ vehicleNo: data.vehicleNo, bay: data.bayNo });

  //     // Hide alert after 5 seconds
  //     setTimeout(() => {
  //       setAlertTruck(null);
  //     }, 5000);
  //   });

  //   return () => {
  //     socket.off("connect");
  //     socket.off("disconnect");
  //     socket.off("truckStatusUpdate");
  //   };
  // }, []);

  useEffect(() => {
    // ✅ First fetch immediately
    fetchTruckData();

    // ✅ Poll every 15 seconds
    const interval = setInterval(() => {
      fetchTruckData();
    }, 15000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // ⏰ Update clock every second
    const timer = setInterval(() => setDateTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);


  return (
    <div style={{ backgroundColor: "black", color: "white", height: "100vh", padding: "20px" }}>
      {/* Header Section */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px", color: "yellow", borderRadius: "10px" }}>
        <div style={{ textAlign: "center", flex: 0.8 }}>
          <h1 style={{ margin: 0, fontSize: "28px" }}>MARUTI SUZUKI INDIA LIMITED</h1>
          <h2 style={{ margin: 0, fontSize: "20px" }}>KHARKODA PLANT, HARYANA</h2>
        </div>
        <div style={{ textAlign: "right", minWidth: "200px", padding: "10px", fontSize: "18px" }}>
          <h3 style={{ margin: 0 }}>{dateTime.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" })}</h3>
          <h3 style={{ margin: 0 }}>{dateTime.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", second: "2-digit" })}</h3>
        </div>
      </div>

      {/* Alert Box */}
      {alertTruck && (
        <div style={{ backgroundColor: "yellow", color: "black", padding: "15px", textAlign: "center", fontSize: "18px", fontWeight: "bold", marginTop: "15px", borderRadius: "8px" }}>
          🚨 **Update Alert:** Vehicle {alertTruck.vehicleNo} has been updated in Bay {alertTruck.bay} 🚨
        </div>
      )}

      {/* Table Header */}
      <h2 style={{ textAlign: "center", marginTop: "20px", textDecoration: "underline" }}>
        Bay Entry Information Display System
      </h2>

      {/* Table */}
      <div style={{
        width: "100%",
        overflowX: "auto",
        maxHeight: "80vh",
      }}>
        <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px", fontSize: "20px" }}>
          <thead>
            <tr style={{ backgroundColor: "red", color: "white", textAlign: "center" }}>
              <th style={{ border: "1px solid grey", padding: "8px" }}>Sl No</th>
              <th style={{ border: "1px solid grey", padding: "8px" }}>Vehicle No</th>
              <th style={{ border: "1px solid grey", padding: "8px" }}>Bay No</th>
              <th style={{ border: "1px solid grey", padding: "8px" }}>Bay Time</th>
              <th style={{ border: "1px solid grey", padding: "8px" }}>Bay Status</th>
            </tr>
          </thead>
          <tbody>
            {truckData.map((entry) => {
              const dotColor = {
                display: "inline-block",
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                backgroundColor:
                  entry.bayStatus === "Parking"
                    ? "#FFD700" 
                    : entry.bayStatus === "Bay Allocated"
                      ? "#00FF00" 
                      : "#FF0000",
              };
              return (
                <tr key={entry.slNo} style={{ textAlign: "center" }}>
                  <td style={{ border: "1px solid grey", padding: "8px" }}>{entry.slNo}</td>
                  <td style={{ border: "1px solid grey", padding: "8px" }}>{entry.vehicleNo}</td>
                  <td style={{ border: "1px solid grey", padding: "8px" }}>{entry.bayNo}</td>
                  <td style={{ border: "1px solid grey", padding: "8px" }}>{entry.time}</td>
                  <td style={{ border: "1px solid grey", padding: "8px" }}>
                    <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                      <span style={dotColor}></span>
                      <span>{entry.bayStatus}</span>
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Dashboard;
